import { FC, useContext, useEffect, useState } from "react";
import { format, isValid, parse, parseISO } from "date-fns";

import { DownloadZipResponseType } from "src/pages/dashboard/types";
import useFetch from "src/hooks/useFetch";
import { APIEndpoints } from "src/types/apiTypes";
import { LoaderContext } from "src/context/loaderContext";

import { CaseInformationProps, DownloadBenefitPDFResponseTypeApi } from "./types";
import { downloadPdfFile } from "src/helpers/downloadFile";
import { DEFAULT_DRUG_NAME } from "src/constants/cases";
import { getQtyLabel } from "src/constants/packOptions";




const CaseInformation: FC<CaseInformationProps> = ({ caseObject }): JSX.Element => {

  const [enabledButton, setEnabledButton] = useState<boolean>(false);
  const { setLoader, hideLoader } = useContext(LoaderContext);

  const {
    data: downloadCaseData, error: downloadCaseError, mutate: downloadRequestForm, removeErrorAndData: clearRequestFileData
  } = useFetch<DownloadZipResponseType>(APIEndpoints.DOWNLOAD_REQUEST_FORM);

  useEffect(() => {
    if (downloadCaseData || downloadCaseError) {
      if (downloadCaseData) {
        const { response } = downloadCaseData;
        downloadPdfFile(response, `case_${caseObject.case_information.id}_reports.pdf`);
      }
      hideLoader();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downloadCaseData, downloadCaseError]);

  const downloadFileByCaseId = () => {
    // OpenForm Enrollment
    if (downloadCaseData || downloadCaseError) clearRequestFileData();
    setLoader();

    if (caseObject && caseObject.case_information)
      downloadRequestForm({}, {}, { ref_id: caseObject.case_information.id, type: caseObject.case_information.category === 'qs2' ? 'qs2' : 'request' , ref_type: 'Case' });
  };





  //////////////////////////////////////////////////Download PDF Benefits////////////////////////////////////////////
  const {
    data: downloadBenefitCaseData, error: downloadBenefitCaseError,
    removeErrorAndData: clearBenefitRequestFileData, mutate: downloadBenefitRequestForm,
  } = useFetch<DownloadBenefitPDFResponseTypeApi>(APIEndpoints.DOWNLOAD_REQUEST_FORM);

  useEffect(() => {
    if (downloadBenefitCaseData || downloadBenefitCaseError) {
      if (downloadBenefitCaseData) {
        const { response, report_name } = downloadBenefitCaseData;
        downloadPdfFile(response, `${report_name}`);
      }
      hideLoader();
      setEnabledButton(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downloadBenefitCaseData, downloadBenefitCaseError]);

  const downloadBenefitClickOnPdf = (refId: number, benefitType: string) => {
    if (downloadBenefitCaseData || downloadBenefitCaseError) clearBenefitRequestFileData();
    setLoader();
    setEnabledButton(true);
    downloadBenefitRequestForm({}, {}, { ref_id: refId, type: DEFAULT_DRUG_NAME+'-investigation', ref_type: 'Insurance', benefit_type: benefitType });
  };

  const formatDate = (date: string | null | undefined) => {
    if (!date) return "-";
    const parsedDate = parseISO(date);
    if (!isValid(parsedDate)) return String(date);
    return format(parsedDate, "MM/dd/yyyy");
  };

  return (
    <>
      <div className="card mb-4">
        <div className="card-header">
          <h1 className="m-0">Case Information</h1>
        </div>
        <div className="card-body">
          <div className="row">

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Created:</p>
              </div>
              <div className="col-6">
                <p>{caseObject && caseObject.case_information ? caseObject.case_information.created : "N/A"}</p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Shipment Date:</p>
              </div>
              <div className="col-6">
                <p>
                  {caseObject && caseObject.case_information ? caseObject.case_information.shipment_date : "N/A"}
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Benefits Type:</p>
              </div>
              <div className="col-6">
                <p>
                  {caseObject && caseObject.case_information ? caseObject.case_information.benefits_type : "N/A"}
                </p>
              </div>
            </div>
          </div>

          
          

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Patient Diagnosis:</p>
              </div>
              <div className="col-6">
                <p>
                  {caseObject && caseObject.case_information ? caseObject.case_information.condition || "N/A" : "N/A"}
                </p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Diagnosis Code:</p>
              </div>
              <div className="col-6">
                <p>
                  {caseObject && caseObject.case_information && caseObject.case_information.diagnosis_code ? caseObject.case_information.diagnosis_code.split(",").join(", ") : "N/A"}
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
              <div className="row">
                <div className="col-6 text-end px-3">
                  <p>Anticipated Date of Service:</p>
                </div>
                <div className="col-6">
                  <p>
                    {caseObject && caseObject.case_information && caseObject.case_information.scheduled_date_of_service && isValid(new Date(caseObject.case_information.scheduled_date_of_service)) ? 
                      format(parse(caseObject.case_information.scheduled_date_of_service, "yyyy-MM-dd", new Date()), "MM/dd/yyyy")
                    : "N/A"}
                  </p>
                </div>
              </div>
            </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Note:</p>
              </div>
              <div className="col-6">
                <p>
                  {caseObject && caseObject.case_information ? caseObject.case_information.note : "N/A"}
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Packaging Size:</p>
              </div>
              <div className="col-6">
                <p>{caseObject && caseObject.prescription_information_attributes?.packaging_size}</p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Quantity & Cartridges Per Box:</p>
              </div>
              <div className="col-6">
                <p>{caseObject && caseObject.case_information && caseObject.case_information.quantity
                  ? getQtyLabel(caseObject.prescription_information_attributes?.packaging_size, caseObject.case_information.quantity)
                  : "N/A"}</p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Inhale:</p>
              </div>
              <div className="col-6">
                <p>{caseObject && caseObject.prescription_information_attributes?.inhale_units}</p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Use Additional:</p>
              </div>
              <div className="col-6">
                <p>{caseObject && caseObject.prescription_information_attributes?.additional_units}</p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Refill:</p>
              </div>
              <div className="col-6">
                <p>{caseObject && caseObject.prescription_information_attributes?.refills}</p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Max Daily Dose:</p>
              </div>
              <div className="col-6">
                <p>{caseObject && caseObject.prescription_information_attributes?.total_daily_units}</p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>FEV1 Date:</p>
              </div>
              <div className="col-6">
                <p>{caseObject && formatDate(caseObject.prescription_information_attributes?.date_of_last_fev1)}</p>
              </div>
            </div>
          </div>
            <div className="col-12 col-md-6">
              <div className="row">
                <div className="col-6 text-end px-3">
                  <p>Written Date:</p>
                </div>
                <div className="col-6">
                  <p>{caseObject && caseObject.case_information ? caseObject.case_information.written_date : "N/A"}</p>
                </div>
              </div>
            </div>
            {/* <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Provide Patient Training:</p>
              </div>
              <div className="col-6">
                {caseObject && caseObject.case_information && caseObject.case_information.patient_training_required === "1" ? "yes" : "no"}
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Target After Meal Blood Glucose Min </p>
              </div>
              <div className="col-6">
                {caseObject && caseObject.case_information && caseObject.case_information.target_after_meal_blood_glucose_min ? caseObject.case_information.target_after_meal_blood_glucose_min : 'N/A'}
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Target After Meal Blood Glucose Max </p>
              </div>
              <div className="col-6">
                {caseObject && caseObject.case_information && caseObject.case_information.target_after_meal_blood_glucose_max ? caseObject.case_information.target_after_meal_blood_glucose_max : 'N/A'}
              </div>
            </div>
            </div> */}
            <div className="col-12 col-md-6">
              <div className="row">
                <div className="col-6 text-end px-3">
                  <p className="mb-0"> Prescription Start Form:</p>
                </div>
                <div className="col-6">
                  <p>
                    <i className="text-primary bi bi-file-pdf fw-bold"></i>
                    <button
                        onClick={downloadFileByCaseId}
                        className="btn btn-link p-0"
                    >
                      Download
                    </button>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="row">
                <div className="col-6 text-end px-3">
                  <p># of Boxes:</p>
                </div>
                <div className="col-6">
                  <p>{caseObject && caseObject.case_information ? caseObject.case_information.number_of_boxes : "N/A"}</p>
                </div>
              </div>
            </div>

           
          </div>
        </div>
      </div>
    </>
  );
};

export default CaseInformation;
